// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  baseUrl: "https://ilms.cuetrans.com/AlTasnimServlet1",  /*"http://localhost:58214/AlTasnimV1"--local use,*/  /*"https://test-altasnim.cuetrans.com/AlTasnimV1"-- test build,*/ /*https://ilms.cuetrans.com/AlTasnimServlet1"-- prod build*/
  calendarBaseUrl: "https://uat-altasnim.cuetrans.com/Altasnim",
  ivmsActualsUrl: "https://om-altasnim.cuetrans.com/IVMSLMS/rest/services/",
  fileUpload:"https://ilms.cuetrans.com/fileUpload/",
  ivmsTenantId: 90,
  actualsTenantId: 117,
  idleTime: 480000,
  idleBufferTime: 60000,
  allocationReserveTiming: "",
  paxRequestRadius: 3000,
  vehicleRadius: 100,
  projectId: 34,
  timeZone: "Asia/Muscat"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
